import React from "react";
import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import Home from "../components/home/Home";

export default function HomeScreenView() {
	return (
		<div className="pageWrapper">
			<Header title="Welkom" needsLocation="Yes" />
			<div className="contentWrapper fadeInDelayed">
				<Home />
			</div>
			<BottomNavBar />
		</div>
	);
}
